import { surfaceShadows } from '../../surfaceStyles';
import { minimumInteractiveSize } from './controlSizing';
import { AddIcon, RemoveIcon } from './icons';
import { IconButton, Stack, TextField, Typography } from '@mui/material';
export function QuantityControl({
  value,
  onChange,
  min = 0,
  disabled = false,
}: {
  value: number | string;
  onChange: (value: number | string) => void;
  min?: number;
  disabled?: boolean;
}) {
  const numeric = typeof value === 'number' ? value : parseInt(value, 10) || 0;
  return (
    <Stack spacing={1} sx={{ width: 'fit-content' }}>
      <Typography variant="body2" fontWeight={600}>
        Quantity
      </Typography>
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          border: 0,
          boxShadow: surfaceShadows.control,
          borderRadius: 1,
          bgcolor: 'background.default',
        }}
      >
        <IconButton
          aria-label="Decrease quantity"
          onClick={() => onChange(Math.max(min, numeric - 1))}
          disabled={disabled || numeric <= min}
          sx={{
            width: minimumInteractiveSize,
            minHeight: minimumInteractiveSize,
          }}
        >
          <RemoveIcon />
        </IconButton>
        <TextField
          size="small"
          type="number"
          value={value}
          disabled={disabled}
          onChange={(event) =>
            onChange(
              event.target.value === ''
                ? ''
                : Math.max(min, Number.parseInt(event.target.value, 10) || min),
            )
          }
          inputProps={{
            min,
            inputMode: 'numeric',
            'aria-label': 'Quantity',
            style: { textAlign: 'center' },
          }}
          sx={{
            width: 72,
            bgcolor: 'background.paper',
            '& input[type=number]': { MozAppearance: 'textfield' },
            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
              {
                WebkitAppearance: 'none',
                margin: 0,
              },
          }}
        />
        <IconButton
          aria-label="Increase quantity"
          onClick={() => onChange(numeric + 1)}
          disabled={disabled}
          sx={{
            width: minimumInteractiveSize,
            minHeight: minimumInteractiveSize,
          }}
        >
          <AddIcon />
        </IconButton>
      </Stack>
    </Stack>
  );
}
